<template lang='pug' src='./thank-you.pug'></template>

<script>
import Loader from 'components/loader/loader'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'

export default {
  name: 'thank-you',
  computed: {
    props () {
      return this.$store.state.pages['thank-you']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    navScrolled () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    notScrolled () {
      this.$store.dispatch('VIEW_NAV', false)
    },
    openModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', {})
    }
  },
  components: {
    Loader,
    VueTrigger
  }
}
</script>

<style>
.thank-you{display: block;width:100%;}
.thank-you h2{float:left;width:100%;text-transform: uppercase;color: #0082bd; font-weight: 400;
	line-height: 1.21;text-align: left;    font-family: "lato", Helvetica, Arial, sans-serif;font-size: 38px;
	margin-bottom: 10px;
}
.footer__container--top{display:none;}
</style>




// WEBPACK FOOTER //
// thank-you.vue?01011c86